import 'normalize.css';
import 'Styles/app.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'Containers/Root';

import TopifyConsoleUtil from 'Utils/topifyConsole';

if ('production' !== process.env.NODE_ENV) {
	let perf = require('react-addons-perf');

	window.startPerf = function() {
		perf.start();
		console.log('Started');
	};

	window.endPerf = function() {
		console.log('Stopping');
		perf.stop();
		console.log('Inclusive:');
		perf.printInclusive(); // Prints the overall time taken.
		console.log('Exclusive:');
		perf.printExclusive(); // Time excluding mounting
		console.log('Wasted');
		perf.printWasted(); // Time spent on components that
//		console.log('DOM:');
//		perf.printOperations();
	};
}

window.TOPIFY_VERSION = TOPIFY_VERSION;

console.log( 'Topify version', TOPIFY_VERSION );

/* Prepare topifyConsole */
/**
 * Adding to the querystring: 'topify_debug=<log_level>'
 * We'll have more or less levels on console when "topifyConsole" in used,
 * this setting doesn't interfere in anyway with other loggers in console
 *
 * We have 5 levels going from 0 to 4:
 *   0 - no logs   * => default on production
 *   1 - only errors
 *   2 - warning, error and timing
 *   3 - info, warning, error and timings
 *   4 - all logs  * => default on development
 *
 */
let _debugMode = () => {
	let locRe = /[?&]topify_debug=([^&]+)/i,
		location = locRe.exec( window.location.search ) || locRe.exec( window.location.hash ),
		query_location = location && location.length > 0 ? { topify_debug: parseInt( location[ 1 ] ) } : false;

	return (
		Number.isInteger( parseInt( query_location[ 'topify_debug' ] ) ) ?
			parseInt( query_location[ 'topify_debug' ] ) :
			false
	);
};

let _debug = () => {
	let debugMode = _debugMode(),
		validMode = Number.isInteger( debugMode ) === true && debugMode <= 4 && debugMode >= 0,
		defaultMode = 'production' === process.env.NODE_ENV ? 0 : 4;

	return validMode ? debugMode : defaultMode;
};

window.topifyConsole = new TopifyConsoleUtil( _debug() );
/* topifyConsole done */


// Render the main component into the dom
ReactDOM.render(
	<Root/>,
	document.getElementById( 'appContainer' )
);



// WEBPACK FOOTER //
// ./src/run.js